import gsap from 'gsap';
import RytmWebflow from 'rytm-webflow'

import { classNames, OBJECT_SCROLL_DISTANCE, VISIBLE_ON_START } from '../constants';
import { scrollTriggerRefresh } from '../shared/common'

class ChapterObjectsView extends RytmWebflow.WebflowView {

  constructor(id) {
    super(id);
  }
  /**
  * animate in (show)
  **/
  show(container) {
    super.show(container);
    this.prepareObjects();
    this.updateContainerHeight();
    this.initScrollTriggers();
  }
  /**
  * animate out (hide)
  **/
  hide(container) {
    super.hide(container);
  }
  // reverse z-indexes and set container height
  prepareObjects = () => {
    const objects = [...this.container.querySelectorAll(`.${classNames.OBJECT}`)];
    objects.reverse().forEach((obj, index) => {
      obj.classList.add(classNames.OBJECT_FIXED);
      obj.style.height = OBJECT_SCROLL_DISTANCE + 'px';
      if (index > objects.length - VISIBLE_ON_START - 1) {
        obj.classList.add(classNames.OBJECT_VISIBLE);
      }
      const fixedCont = obj.querySelector('.fixed-container');
      fixedCont.style.zIndex = index + 1;
    });
  }
  updateContainerHeight = () => {
    const objects = this.container ? [...this.container.querySelectorAll(`.${classNames.OBJECT}`)] : [];
    if (objects.length) {
      const minHeight = window.innerHeight + 100;
      let height = OBJECT_SCROLL_DISTANCE * (objects.length) + window.innerHeight;
      height = height > minHeight ? height : minHeight;
      this.container.style.height = height + 'px';
    }
  }
  /**
   * #######################
   * ### Scroll Triggers ###
   */
  initScrollTriggers = () => {
    // PIN + toggle body class
    gsap.to('.chapter-objects', {
      scrollTrigger: {
        toggleActions: "restart none none reverse",
        trigger: '.chapter-objects',
        start: 'top top',
        end: 'bottom bottom',
        // markers: true,
        toggleClass: { targets: 'body', className: classNames.CHAPTER_LISTING },
        pin: true,
        pinSpacing: false,
      },
    });
    // scrub body background color
    gsap.set('.chapter-full', { backgroundColor: 'transparent' });
    gsap.to('.chapter-full', {
      scrollTrigger: {
        toggleActions: "restart none none reverse",
        trigger: '.chapter-objects',
        scrub: true,
        start: 'top 300px',
        end: 'top top',
      },
      backgroundColor: '#FFFFFF',
    });
  }
  /**
   * ### End: Scroll Triggers ###
   * ############################
   */

}

export default ChapterObjectsView